// extracted by mini-css-extract-plugin
export default {"adminPanel":"adminPanel_adminPanel__1g9Hz","deleteButton":"adminPanel_deleteButton__UcPNa"};